const customJsSelectBox =  {
    openedSelectBox: null,
    initializedDocumentClickHandler: false,

    translations: {
        cs: {
            Searching: 'Vyhledávání',
            NoResults: 'Žádné výsledky',
        },
        sk: {
            Searching: 'Vyhľadávanie',
            NoResults: 'Žiadne výsledky',
        },
        en: {
            Searching: 'Searching',
            NoResults: 'No results',
        },
        fr: {
            Searching: 'Chercher',
            NoResults: 'Aucun résultat',
        },
        it: {
            Searching: 'Ricerca',
            NoResults: 'Nessun risultato',
        },
        es: {
            Searching: 'Búsqueda',
            NoResults: 'No hay resultados',
        },
        de: {
            Searching: 'Suche',
            NoResults: 'Keine Ergebnisse',
        },
    },

    init() {
        let self = this;

        document.querySelectorAll('.js-custom-select:not(.js-select-initialized)').forEach(selectNode => {
            self._constructSelectBox(selectNode);
        });

        if (! self.initializedDocumentClickHandler) {
            document.addEventListener('click', (event) => {
                if (self.openedSelectBox && ! self.openedSelectBox._customSelectNode.contains(event.target)) {
                    self._close(self.openedSelectBox);
                }
            });
            self.initializedDocumentClickHandler = true;
        }
    },

    _constructSelectBox(selectNode) {
        let self = this;
        let notFoundNode;

        let optionsNodes = Array.prototype.slice.call(selectNode.options);
        selectNode._enableSearch = selectNode.dataset.enableSearch !== 'false';

        let wrapperNode = document.createElement('div');
        wrapperNode.classList.add('c-custom-select');

        // fake selected item
        let selectedNode = document.createElement('div');
        selectedNode.classList.add('c-custom-select__selected');
        selectedNode.onclick = () => {
            self[itemsNode.hidden ? '_open' : '_close'](selectNode);
        };

        for (let option of optionsNodes) {
            if (option.value === selectNode.value) {
                selectedNode.innerHTML = option.dataset.text ? option.dataset.text : option.innerText;
                break;
            }
        }

        // fake options
        let itemsNode = document.createElement('div');
        itemsNode.classList.add('c-custom-select__items');
        itemsNode.hidden = true;

        // fake options - search bar
        if (selectNode._enableSearch) {
            notFoundNode = document.createElement('div');
            notFoundNode.classList.add('c-custom-select__items-not-found');
            notFoundNode.innerText = self._translate('NoResults');
            notFoundNode.hidden = true;

            // fake options - search bar
            let searchNode = document.createElement('input');
            searchNode.classList.add('c-custom-select__items-search');
            searchNode.type = 'search';
            searchNode.placeholder = self._translate('Searching');
            searchNode.oninput = () => {
                let hasResults = false;
                let phrase = self._sanitizeString(searchNode.value);
                selectNode._customSelectNode.classList[phrase ? 'add' : 'remove']('searching');

                itemsNode.querySelectorAll('.c-custom-select__items-item').forEach((itemNode) => {
                    if (! phrase || itemNode._text.indexOf(phrase) !== -1) {
                        hasResults = true;
                        itemNode.hidden = false;
                    } else {
                        itemNode.hidden = true;
                    }
                });

                notFoundNode.hidden = hasResults;
            }
            itemsNode.appendChild(searchNode);
        }

        // fake options - options
        for (let option of optionsNodes) {
            let itemNode = document.createElement('div');
            itemNode.classList.add('c-custom-select__items-item');
            itemNode.innerHTML = option.dataset.text ? option.dataset.text : option.innerText;
            itemNode._text = self._sanitizeString(option.innerText);
            itemNode.onclick = () => {
                itemNode.classList.add('selected');
                selectedNode.innerHTML = option.dataset.text ? option.dataset.text : option.innerText;

                let selectedItemNode = itemsNode.querySelector('.selected');
                if (selectedItemNode) {
                    selectedItemNode.classList.remove('selected');
                }

                self._close(selectNode);
                selectNode.value = option.value;
                selectNode.dispatchEvent(new Event('change'));
            };

            itemsNode.appendChild(itemNode);
        }


        // build
        if (selectNode._enableSearch) {
            itemsNode.appendChild(notFoundNode);
        }
        wrapperNode.appendChild(selectedNode);
        wrapperNode.appendChild(itemsNode);
        selectNode.parentNode.insertBefore(wrapperNode, selectNode.nextSibling);
        selectNode.classList.add('js-select-initialized');
        selectNode._customSelectNode = wrapperNode;
        selectNode.hidden = true;
    },

    _open(selectNode) {
        let self = this;

        selectNode._customSelectNode.querySelector('.c-custom-select__items').hidden = false;
        selectNode._customSelectNode.classList.add('opened');
        if (self.openedSelectBox) {
            self._close(self.openedSelectBox);
        }

        self.openedSelectBox = selectNode;

        if (selectNode._enableSearch) {
            document.addEventListener('keydown', self._swapKeyDownEvent);
        }
    },

    _close(selectNode) {
        let self = this;

        selectNode._customSelectNode.classList.remove('opened');
        selectNode._customSelectNode.querySelector('.c-custom-select__items').hidden = true;
        selectNode._customSelectNode.querySelectorAll('.c-custom-select__items-item').forEach((itemNode) => {
            itemNode.hidden = false;
        });

        self.openedSelectBox = null;

        if (selectNode._enableSearch) {
            selectNode._customSelectNode.querySelector('.c-custom-select__items-search').value = '';
            document.removeEventListener('keydown', self._swapKeyDownEvent);
        }
    },

    _sanitizeString(value) {
        value = value.toLowerCase();
        value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        value = value.replace(/[\W_]+/g,'');

        return value;
    },

    _translate(key) {
        let self = this;

        if (typeof self.translations[document.documentElement.lang][key] === 'undefined') {
            return key;
        }

        return self.translations[document.documentElement.lang][key];
    },

    _swapKeyDownEvent(event) {
        if (event.target.classList.contains('c-custom-select__items-search')) {
            return;
        }

        document.querySelector('.c-custom-select.opened .c-custom-select__items-search').focus();
    },
};

customJsSelectBox.init();

document.addEventListener('LokiRequestEnd', function () {
    customJsSelectBox.init();
});